import React from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuCheckboxItem, DropdownMenuTrigger, DropdownMenuSeparator, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

export default function MultiSelect({ allLabel, options, value, onChange, testid, width = "w-[190px]" }) {
  const sel = value || [];
  const toggle = (k) => onChange(sel.includes(k) ? sel.filter((x) => x !== k) : [...sel, k]);
  const summary = sel.length === 0
    ? allLabel
    : sel.length === 1
      ? (options.find((o) => o.value === sel[0])?.label || "1 selected")
      : `${sel.length} selected`;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className={`justify-between gap-2 ${width}`} data-testid={testid}>
          <span className="truncate">{summary}</span>
          <ChevronDown className="h-4 w-4 opacity-60 shrink-0" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56 max-h-72 overflow-auto">
        {options.map((o) => (
          <DropdownMenuCheckboxItem key={o.value} checked={sel.includes(o.value)}
                                    onCheckedChange={() => toggle(o.value)} onSelect={(e) => e.preventDefault()}
                                    data-testid={`${testid}-opt-${o.value}`}>
            {o.label}
          </DropdownMenuCheckboxItem>
        ))}
        {sel.length > 0 && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => onChange([])} data-testid={`${testid}-clear`}>Clear selection</DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
